import{UPDATE_FILTERS}from"../constants";/**
 * @param {Object} filters The set filters.
 * @return {Object}
 */export var updateFilters=function updateFilters(filters){return{type:UPDATE_FILTERS,filters:filters};};